import { render, staticRenderFns } from "./ConfirmModal.vue?vue&type=template&id=067c586a&scoped=true&"
import script from "./ConfirmModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./ConfirmModal.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067c586a",
  null
  
)

export default component.exports